/** 「联系我们」页内容。 */

import type { IconName } from './icons';

export const CONTACT_INTRO = {
  eyebrow: '联系我们',
  title: '直接说明情况，比填写十几个字段更高效',
  lead: '平台接入咨询、企业定制与私有化部署，均可直接来信。我们按收到顺序回复；来信中附上机体型号与应用场景，回复会更具体。',
} as const;

export interface Channel {
  id: string;
  icon: IconName;
  label: string;
  value: string;
  href: string;
  external?: boolean;
  note: string;
}

export const CONTACT_CHANNELS: readonly Channel[] = [
  {
    id: 'email',
    icon: 'mail',
    label: '邮箱',
    value: 'contact@havorix.cn',
    href: 'mailto:contact@havorix.cn',
    note: '咨询、接入、合作与联络，均使用此地址。',
  },
  {
    id: 'github',
    icon: 'code',
    label: 'GitHub',
    value: 'github.com/Havorix-Aero',
    href: 'https://github.com/Havorix-Aero',
    external: true,
    note: '查阅源码、提交 issue、了解实现细节。',
  },
  {
    id: 'platform',
    icon: 'globe',
    label: '平台入口',
    value: 'havorix.work',
    href: 'https://havorix.work',
    external: true,
    note: '平台本体；内置模拟机体，可直接查看。',
  },
];

export interface DeclarationBlock {
  icon: IconName;
  title: string;
  paragraphs: readonly string[];
}

export const DECLARATIONS: readonly DeclarationBlock[] = [
  {
    icon: 'wrench',
    title: '我们不销售无人机整机',
    paragraphs: [
      'Havorix™ 提供的是无人机运营监管平台与配套软硬件方案。我们不出售、也不代理任何无人机整机，站内没有商城，也没有购买入口。',
      '贵方使用何种机体由自身决定；只要满足公开的接口约定，即可接入平台。',
    ],
  },
  {
    icon: 'lock',
    title: '联系方式的用途',
    paragraphs: [
      '邮件仅用于回复本次沟通。我们不建立邮件列表、不发送营销邮件，也不会将联系方式提供给第三方。',
      '页面上的表单不会将内容发送至任何服务器：它仅在您的浏览器中拼装一封邮件，或复制一份正文供您使用。',
    ],
  },
];

export interface ContactFaq {
  q: string;
  a: string;
}

export const CONTACT_FAQ: readonly ContactFaq[] = [
  {
    q: '通常多久回复？',
    a: '我们按收到顺序处理。首次回复通常由人工撰写而非自动应答；若内容需内部确认，您可能会先收到一封简短的答复。',
  },
  {
    q: '可以直接提交需求或反馈缺陷吗？',
    a: '可以。涉及实现细节的建议，走 GitHub issue 更便于我们记录与跟进；商务与应用场景相关的，来信更为合适。',
  },
  {
    q: '能否提供发票与合同？',
    a: '企业合作按标准流程签署合同并开具发票，具体主体信息在方案确认后提供。',
  },
];
